<template>
  <div class="rpt-content">
    <div class="search-box">
      <el-input class="search-control-item" style="width: 200px;" v-model="companyName" placeholder="企业名称"></el-input>

      <el-date-picker
        class="search-control-item"
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyyMMdd"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-button class="search-control-item" type="primary" icon="el-icon-search" @click="search('btn')">查询</el-button>
    </div>

    <el-table border v-loading="tableloading" :data="tableData" style="width: 100%" max-height="600">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="apply_date" label="申请日期">
        <template slot-scope="scope">
          <span>{{ formatDateTime(scope.row.apply_date) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="product_name" label="产品类型"></el-table-column>
      <el-table-column prop="apply_user_tel" label="企业管理员"></el-table-column>
      <el-table-column prop="company_name" width="300" label="企业名称"></el-table-column>
      <el-table-column prop="credit_code" width="190" label="统一社会信用代码"></el-table-column>
      <el-table-column prop="model_result" label="模型结果" width="250">
        <template slot-scope="scope">
          <textarea
            disabled
            :value="JSON.stringify(JSON.parse(scope.row.model_result), null, 2)"
            style="max-width: 100%; width: 100%; height: 100px; text-overflow: ellipsis; overflow: auto;"
            :title="JSON.stringify(JSON.parse(scope.row.model_result), null, 2)"
          ></textarea>
        </template>
      </el-table-column>
      <el-table-column prop="province_name" label="所在省份"></el-table-column>
      <el-table-column prop="city_name" label="所在城市"></el-table-column>
      <el-table-column prop="area_name" label="所在区域"></el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[50, 100, 200, 300]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
export default {
  name: 'apply-detail',
  data() {
    return {
      tableloading: false,
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      tableData: [],
      date: [],
      companyName: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '今年',
            onClick(picker) {
              const now = new Date();
              const start = new Date(`${now.getFullYear()}/1/1`);
              picker.$emit('pick', [start, now]);
            }
          },
          {
            text: '上月',
            onClick(picker) {
              const now = new Date();
              const end = new Date(now.setDate(0));
              const start = new Date(`${end.getFullYear()}/${end.getMonth() + 1}/1`);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const now = new Date();
              const start = new Date(`${now.getFullYear()}/${now.getMonth() + 1}/1`);
              picker.$emit('pick', [start, now]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.search();
    },
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.search();
    },
    search(type) {
      if (type == 'btn') this.pageIndex = 1;
      this.tableloading = true;
      let start = this.date?.length > 0 ? `${this.date[0]}000000` : '';

      let end = this.date?.length > 0 ? `${this.date[1]}235959` : '';
      request({
        url: `/api/rpt/apply/company/detail?company_name=${this.companyName}&begin_date=${start}&end_date=${end}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`
      }).then(res => {
        this.tableloading = false;
        if (res.success) {
          this.tableData = res?.result?.applyList;
          this.total = res?.result?.recordCount;
        }
      });
    }
  }
};
</script>

<style></style>
